import FileDownloadIcon from '@mui/icons-material/FileDownload';

import DataGrid from 'app/components/DataGrid';
import useAnalyticsReport from 'app/hooks/useAnalyticsReport';

import {
  getAnalyticsReport
} from 'app/services/reports';

const AnalyticsReport = () => {
  const header = 'Analytics Report';

  const {
    resource,
    onDataGridLoad,
    showFilters,
    getRowData,
    getFilterModel
  } = useAnalyticsReport();

  const exportCSV = () => {
    let params = {
      page: 1,
      per_page: 100,
      is_export: true
    }

    const filterModel = getFilterModel();
    if (filterModel) {
      params.filter_model = filterModel;
    }

    params.selected_dropdown_filter = { key: 'ANALYTICS_REPORT', value: 'ANALYTICS_REPORT', label: 'Analytics Report' }

    getAnalyticsReport(params).then((resp => resp.blob())).then((blob) => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `analytics_report_${new Date().toISOString()}.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  const getReportColumns = () => {
    return [
      {
        field: 'id',
        headerName: 'Job Id',
        inputType: 'number',
      },
      {
        field: 'name',
        headerName: 'Job name'
      },
      {
        field: 'with_images',
        headerName: 'With Images',
        inputType: 'number',
      },
      {
        field: 'viewed',
        headerName: 'Viewed',
        inputType: 'number',
      },
      {
        field: 'shared',
        headerName: 'Shared',
        inputType: 'number',
      },
      {
        field: 'downloaded',
        headerName: 'Downloaded',
        inputType: 'number',
      },
      {
        field: 'with_phone',
        headerName: 'With Phone',
        inputType: 'number',
      },
    ]
  }

  const columnDefOverrides = getReportColumns();
  const columnOrder = columnDefOverrides.map((column) => column.field);
  const visibleColumns = [].concat(columnOrder);

  const buttons = [
    {
      key: 'export',
      icon: <FileDownloadIcon />,
      label: 'Export CSV',
      onClick: exportCSV
    }
  ]

  return <div>
    <DataGrid
      header={header}
      resource={resource}
      defaultDropdownOption={{ key: 'ANALYTICS_REPORT', value: 'ANALYTICS_REPORT', label: 'Analytics Report' }}
      showDropDown={false}
      getRowData={getRowData}
      showFilters={showFilters}
      onDataGridLoad={onDataGridLoad}
      columnOrder={columnOrder}
      columnDefOverrides={columnDefOverrides}
      visibleColumns={visibleColumns}
      loadingMessage="Loading report..."
      buttons={buttons}
    />
  </div>
}

export default AnalyticsReport;
